import { render } from "./EditForeignEmployee.vue?vue&type=template&id=79091ec8"
import script from "./EditForeignEmployee.vue?vue&type=script&lang=js"
export * from "./EditForeignEmployee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__